import authApi from "./authApi";
import { decodeToken } from "../../utility/JwtUtility";
import localStorageUtil from "../../utility/localStorageUtil";
import UserRoles from "../../routes/userRoles.type";
export class AuthResult {
  success: boolean;
  message: string;

  constructor(success: boolean, message: string) {
    this.success = success;
    this.message = message;
  }
}

class AuthManager {
  public async login(
    userName: string,
    password: string,
    remember: boolean
  ): Promise<AuthResult> {
    try {
      const authResponse = await authApi.login({
        username: userName,
        password,
      });
      if (authResponse.success && authResponse.value.accesstoken !== null) {
        const tokenStorage = remember ? localStorage : sessionStorage;
        // get the role here
        tokenStorage.setItem("accessToken", authResponse.value.accesstoken);
        // this.addUserRoles();

        return new AuthResult(true, "Login success");
      } else {
        console.log("errroer");
        return { success: false, message: "error" };
        // return new AuthResult(false, authResponse.error.message);
      }
    } catch (error) {
      console.error("Login failed:", error);
      return new AuthResult(false, "Login failed");
    }
  }

  public isLoggedIn(): boolean {
    return !!this.getAccessToken();
    // return true;
  }

  public logout(): void {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("userEmail");

    sessionStorage.removeItem("accessToken");
    sessionStorage.removeItem("refreshToken");
    sessionStorage.removeItem("userAuthRole");
    sessionStorage.removeItem("userEmail");
    localStorage.clear();
    window.location.assign("/login");
  }

  public getAccessToken(): string | null {
    return (
      localStorage.getItem("accessToken") ||
      sessionStorage.getItem("accessToken")
    );
  }

  public addUserRoles(): void {
    const accessToken = localStorageUtil.getLocalStorage("accessToken");
    if (accessToken) {
      const userAuthRole = decodeToken(accessToken);
      // console.log(userAuthRole);
      localStorageUtil.setLocalStorage("userAuthRole", userAuthRole.role);
      localStorageUtil.setLocalStorage("userEmail", userAuthRole.email);
    }
  }

  public getUserEmail(): string | null {
    return (
      localStorage.getItem("userEmail") || sessionStorage.getItem("userEmail")
    );
  }

  public isUserHasPermission(): boolean {
    const accessToken = localStorageUtil.getLocalStorage("accessToken");
    if (accessToken) {
      const userAuthRole = decodeToken(accessToken);

      const userRole: any = userAuthRole.role;
      if (userRole !== undefined || userRole !== "") {
        return [UserRoles.ADMIN, UserRoles.MANAGER].includes(
          parseInt(userRole)
        );
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  public getUserRole(): UserRoles | undefined {
    const accessToken = localStorageUtil.getLocalStorage("accessToken");
    if (accessToken) {
      const userAuthRole = decodeToken(accessToken);
      const userRole: any = userAuthRole.role;
      if (userRole !== undefined || userRole !== "") {
        return UserRoles[
          UserRoles[parseInt(userRole)] as keyof typeof UserRoles
        ];
      } else {
        return undefined;
      }
    } else {
      return undefined;
    }
  }
}

const authManager = new AuthManager();
export default authManager;
